// addPeriodToTestss.js
import moment from 'moment';
import 'moment/locale/sv';
import {updateObject} from 'utils/reducerUtils';

const LOCALE = 'sv';

moment.locale(LOCALE);

const parseSvMoment = (v) => {
	if (v == null || v === 'undefined' || v === 'null') return null;

	if (moment.isMoment(v)) {
		const m = v.clone().locale(LOCALE);
		return m.isValid() ? m : null;
	}

	if (typeof v === 'number') {
		const m = v < 1e12 ? moment.unix(v) : moment(v);
		return m.isValid() ? m.locale(LOCALE) : null;
	}

	let m = moment(v, moment.ISO_8601, true);

	if (!m.isValid()) {
		m = moment(v);
	}

	return m.isValid() ? m.locale(LOCALE) : null;
};

const addPeriodToTests = (row) => {
	const createdAt = parseSvMoment(row.createdAt);
	const distributedAt = parseSvMoment(row.distributedAt);
	const usedAt = row.isUsed ? parseSvMoment(row.usedAt) : null;
	const completedAt = parseSvMoment(row.completedAt);

	const groupAt =
		distributedAt ||
		usedAt ||
		completedAt ||
		createdAt ||
		moment().locale(LOCALE);

	const safeCreatedAt = createdAt || groupAt;

	return updateObject(row, {
		createdAt: safeCreatedAt.locale(LOCALE),
		distributedAt: distributedAt && distributedAt.locale(LOCALE),
		usedAt: usedAt && usedAt.locale(LOCALE),
		completedAt: completedAt && completedAt.locale(LOCALE),
		groupAt: groupAt.locale(LOCALE),
	});
};

export default function addPeriodToTestss(rows) {
	return rows.map(addPeriodToTests);
}
